import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { invalidateQuery } from '@/utils/queries';

import { hiringManagerLinkedInEndpoints } from './constants';
import { hiringManagerLinkedInQueryKeys } from './queryKeys';

export const useConnectHiringManagerLinkedInMutation = () => {
  return useMutation({
    mutationFn: async (tenantId: string) => {
      const { data } = await fetchClient.POST(
        hiringManagerLinkedInEndpoints.account,
        { params: { query: { tenantId } } },
      );
      return data;
    },
    onSettled: (_result, _error, tenantId) => {
      invalidateQuery(hiringManagerLinkedInQueryKeys.account(tenantId))();
    },
  });
};
